import React, { useEffect, useState } from 'react'
import { Card, Tabs, Image } from 'antd';
import FoodTracking from './tabs/food-tracking';
import WeightTracking from './tabs/weight-tracking';
import ManuallyTracking from './tabs/manually-tracking';
import CONSTANTS from '../../../util/constant/CONSTANTS';
import DeviceDetails from './tabs/device-details';
import ModeHistory from './tabs/modeHistory';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import BackButton from '../../../component/common/Back-Button';
import { role } from '../../../util/Route';
import { apiGenerator } from '../../../util/functions';
import useHttp from '../../../hooks/use-http';
import DeviceErrorLogs from './tabs/device-error-logs';
import FeederErrorLogs from './tabs/feeder-error-logs';
import FeederInfo from './tabs/feeder-info';
import LocationHistory from './location-hisotry';
import temp_img from '../../../asset/image/dummy-avatar.jpg'

const PetDetails = () => {
    const [info, setInfo] = useState(null)
    const { id } = useParams();
    const api = useHttp();
    const commonClass = "text-base ";

    const menus = {
        device: <DeviceDetails {...info} />,
        deviceLogs: <DeviceErrorLogs {...info} />,
        feeder: <FeederInfo {...info} />,
        feederLogs: <FeederErrorLogs {...info} />,
        food: <FoodTracking />,
        weight: <WeightTracking />,
        manually: <ManuallyTracking />,
        mode: <ModeHistory />
    };
    const location = useLocation();
    const navigate = useNavigate()

    useEffect(() => {
        const DEVICE_API = apiGenerator(CONSTANTS.API.Pet.getOne, { id });

        api.sendRequest(DEVICE_API, (res) => {
            setInfo((prev) => {
                return {
                    ...prev,
                    ...res?.data,
                    feedarId: res?.data?.feederConnections?.length > 0 ? res?.data?.feederConnections[0]?.feedarId : null,
                    feederConnectionId: res?.data?.feederConnections?.length > 0 ? res?.data?.feederConnections[0]?.id : null,
                    deviceId: res?.data?.petDevices?.length > 0 ? res?.data?.petDevices[0]?.id : null,

                }
            })
        })
    }, [])

    return (
        <>
            <div >
                <div className='grid gap-5 grid-cols-3 my-8 '>
                    <Card className="" >
                        <div className="flex items-center gap-3">
                            <div>
                                <Image className="rounded-full object-cover" width={70} height={70} src={info?.image || temp_img} alt='user profile' />
                            </div>
                            <div>
                                <p className="font-medium text-xl">{info?.name}</p>
                            </div>
                        </div>
                        {/* Device ID */}
                        <p className={`${commonClass} my-3`}>
                            Device ID : {info?.petDevices[0]?.device?.DID}
                        </p>
                        {/* Device Status */}
                        <p className={`${commonClass}`}>
                            Device Status : {info?.petDevices[0]?.device?.isActive ? <span className="text-[#179415]">Active</span> : <span className="text-[#F44400]">In-Active</span>}
                        </p>
                    </Card>
                    <Card className="" >
                        <div className="flex items-center gap-3">
                            <div>
                                <Image className="rounded-full object-cover" width={70} height={70} src={info?.user?.profilePic || temp_img} alt='user profile' />
                            </div>
                            <div>
                                <p className="font-medium text-xl">{info?.user?.name}</p>
                            </div>
                        </div>
                        {/* Mobile */}
                        <p className={`${commonClass} my-3`}>
                            Mobile : {info?.user?.mobile}
                        </p>
                        {/* Email */}
                        <p className={`${commonClass}`}>
                            Email : {info?.user?.email}
                        </p>
                    </Card>
                    {info?.familyMemberPetAccesses?.length > 0 && <Card className="" >
                        <p className='text-xl font-medium'>
                            Other Family Members
                        </p>
                        <div className='flex items-center mt-3 gap-3 flex-wrap'>
                            {info?.familyMemberPetAccesses?.length > 0 && info?.familyMemberPetAccesses?.map(ele => <div key={ele?.id} className="flex items-center gap-1.5">
                                <div>
                                    <Image className="rounded-full object-cover" width={30} height={30} src={ele?.familyMemberAccess?.familyMember?.profilePic || temp_img} alt='user profile' />
                                </div>
                                <div>
                                    <p className="font-medium text-sm">{ele?.familyMemberAccess?.name}</p>
                                </div>
                            </div>)}

                        </div>

                    </Card>}
                </div>
                <Card className="my-5">
                    {role === 'Admin' && <BackButton onClick={() => navigate(-1)} />}
                    <Tabs
                        className="p-0 m-0"
                        defaultActiveKey={location?.state ? location.state?.active : "device"}
                        size="middle"
                        type="card"
                        items={CONSTANTS.TAB_MENU.PET.map((ele) => {
                            if (ele.Role.includes(role)) {
                                return {
                                    label: `${ele.Label}`,
                                    key: `${ele.id}`,
                                    children: menus[ele?.id],
                                };
                            }
                        })}
                    />
                </Card>
                {role === 'Admin' && <div>
                    <LocationHistory id={id} />
                </div>}
            </div>
        </>
    );
}

export default PetDetails